/**
 * ⚠️ WARNING ⚠️
 * This file is automatically generated do not edit it manually",
 */
import React from "react";

import { chevronRight } from "../assets/chevron-right";
import { Icon, type IconBaseProps } from "../icon";

export const IconChevronRight = (props: IconBaseProps) => <Icon {...props} svg={chevronRight} />;

IconChevronRight.displayName = "IconChevronRight";
